module.exports = __webpack_public_path__ + "static/media/BirchStd-01.fefd072a.svg";